<template>
  <div
    data-component-group="threads-panel"
    data-component="primary-actions"
    :class="getClass()"
  >
    <v-btn
      v-if="canView('accept')"
      class="trigger accept"
      color="success"
      @click="accept"
    >
      {{ 'Accept' }}
    </v-btn>

    <v-btn
      v-if="canView('deny')"
      class="trigger deny"
      color="error"
      @click="deny"
    >
      {{ 'Deny' }}
    </v-btn>
  </div>
</template>

<script>
  import { isObj, isArr } from '../../../utils';

  // TODO: Translate component

  export default {
    props: {
      thread: {
        type: Object,
        default: undefined,
      },
      totalSelected: {
        type: Number,
        default: 0,
      },
      actions: {
        type: Array,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      canSearch: {
        type: Boolean,
        default: true,
      },
      onChangeItem: {
        type: Function,
        required: true,
      },
    },
    data() {
      return {
        items: [],
        isLoading: false,
      };
    },
    computed: {
      hasThread() {
        return isObj(this.thread);
      },
    },
    watch: {
      actions(nextActions) {
        this.setActions(nextActions);
      },
    },
    created() {
      this.setActions(this.actions);
    },
    methods: {
      accept() {
        const acceptAction = this.filterActions('accept')[0];
        this.onChangeItem(acceptAction);
      },
      deny() {
        const denyAction = this.filterActions('deny')[0];
        this.onChangeItem(denyAction);
      },
      setActions(nextActions) {
        this.items = nextActions;

        const canDeny =
          this.$ability.can('mass-deny', 'thread') ||
          (this.hasThread &&
            isArr(this.thread.permissions) &&
            this.thread.permissions.indexOf('deny-with-comment') > -1);

        if (!canDeny) {
          this.items = this.items.filter(({ action }) => action !== 'deny');
        }

        if (
          !this.$ability.can('accept', 'thread') ||
          !this.$ability.can('see-accept-link', 'thread')
        ) {
          this.items = this.items.filter(({ action }) => action !== 'accept');
        }
      },
      changeItem(item) {
        this.onChangeItem(item);
      },
      filterActions(action) {
        return this.items.filter((item) => item.action === action);
      },
      canView(action) {
        return this.filterActions(action).length > 0;
      },
      getLabel(action) {
        // TODO: Consider removing if dynamic labels are not required
        const matches = this.filterActions(action);
        return matches.length > 0 ? matches[0].label : '';
      },
      getClass() {
        return {
          hidden: !this.canView('accept') && !this.canView('deny'),
        };
      },
    },
  };
</script>

<style lang="scss">
@use '../../../assets/styles/theme' as *;

[data-component-group='threads-panel'] {
  &[data-component='primary-actions'] {
    display: flex;
    gap: 16px;
    margin: 0 0 0 16px;

    &.hidden {
      display: none;
    }

    .v-btn {
      height: 34px;
      min-height: 34px;
      margin: 0 16px 0 0;

      &:last-child {
        margin: 0;
      }
    }
  }
}
</style>
